module.exports = __webpack_public_path__ + "static/media/gsd8.7cfcd445.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/fi/gsd8.png
// module id = 140
// module chunks = 0